import React from 'react';

const getStyle = props => ({
	display: 'flex',
	alignItems: 'center',
	color: '#fff',
	justifyContent: 'center',
	width: 24,
	height: 24,
	fontSize: '9px',
	borderRadius: 2,
	backgroundColor: props.isActive ? '#46bc98' : '#777',
});

export const CharBadge = props => {
	const style = getStyle(props);
	return <div style={style} {...props} />;
};



// WEBPACK FOOTER //
// src/components/ui/char-badge/char-badge.jsx